<a
  [routerLink]="link()"
  class="link"
  [routerLinkActiveOptions]="activeOptions"
  routerLinkActive="active"
  #rla="routerLinkActive">
  @if (rla.isActive) {
    <pu-icon class="icon" [iconName]="iconName() + '-filled'"> </pu-icon>
  } @else {
    <pu-icon class="icon" [iconName]="iconName()"> </pu-icon>
  }

  <span [translate]="i18nKey()"> </span>
</a>
